const isActive = ({panelState}, id) => {
    return panelState.current === id;
};

export {
    isActive,
}
